export enum PlatformEnum {
  Web = 'web',
  Mobile = 'mobile',
  Kiosk = 'kiosk',
}
